import { render } from "./Category.vue?vue&type=template&id=2bbde8e7&scoped=true&ts=true"
import script from "./Category.vue?vue&type=script&lang=ts"
export * from "./Category.vue?vue&type=script&lang=ts"

import "./Category.vue?vue&type=style&index=0&id=2bbde8e7&lang=scss&scoped=true"
import "./Category.vue?vue&type=style&index=1&id=2bbde8e7&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbde8e7"]])

export default __exports__